// role names and ids
export const Survyor = 'Survyor';
export const SurvyorRoleId = -69;
export const HospicePhysician = 'Hospice Physician';
export const HospicePhysicianRoleId = -66;
export const LicencedClinicalSocialWorker = 'Licenced Clinical Social Worker';
export const LicencedClinicalSocialWorkerRoleId = -64;
export const LCSW = 'LCSW';
export const PhysicianAssistant = 'Physician Assistant';
export const PhysicianAssistantRoleId = -61;
export const CertifiedIndependentSocialWorker = 'Certified Independent Social Worker';
export const CertifiedIndependentSocialWorkerRoleId = -56;
export const CISW = 'CISW';
export const Homemaker = 'Homemaker';
export const HomemakerRoleId = -52;
export const DoctorOfOsteopathy = 'Doctor Of Osteopathy';
export const DoctorOfOsteopathyRoleId = -51;
export const HC = 'HC';
export const HISClerk = 'HIS Clerk';
export const HISClerkRoleId = -50;
export const RegesteredDietician = 'Regestered Dietician';
export const RegesteredDieticianRoleId = -49;
export const RegisteredPharmacist = 'Registered Pharmacist';
export const RegisteredPharmacistRoleId = -48;
export const Pharmacist = 'Pharmacist';
export const PharmacistRoleId = -47;
export const BereavementClerk = 'Bereavement Clerk';
export const BereavementClerkRoleId = -46;
export const BereavementCoordinator = 'Bereavement Coordinator';
export const BereavementCoordinatorRoleId = -45;
export const PatientCareVolunteer = 'PatientCareVolunteer';
export const PatientCareVolunteerRoleId = -23;
export const OfficeVolunteer = 'Office Volunteer';
export const OfficeVolunteerRoleId = -22;
export const VolunteerCoordinator = 'Volunteer Coordinator';
export const VolunteerCoordinatorRG = 'VC';
export const VolunteerCoordinatorRoleId = -21;
export const Chaplain = 'Chaplain';
export const ChaplainRoleId = -20;
export const HomeHealthAide = 'Home Health Aide';
export const HomeHealthAideRoleId = -19;
export const CertifiedNurseAssistant = 'Certified Nurse Assistant';
export const CertifiedNurseAssistantRoleId = -18;
export const SocialWorker = 'Social Worker';
export const SocialWorkerRoleId = -17;
export const SW = 'SW';
export const SpeechTherapist = 'Speech Therapist';
export const SpeechTherapistRoleId = -16;
export const OccupationalTherapist = 'Occupational Therapist';
export const OccupationalTherapistRoleId = -15;
export const PhysicalTherapist = 'Physical Therapist';
export const PhysicalTherapistRoleId = -14;
export const RegisteredNurse = 'Registered Nurse';
export const RegisteredNurseRoleId = -13;
export const LicencedPracticalNurse = 'Licenced Practical Nurse';
export const LicencedPracticalNurseRoleId = -12;
export const NursePractitioner = 'Nurse Practitioner';
export const NursePractitionerRoleId = -11;
export const MedicalDirector = 'Medical Director';
export const MedicalDirectorRoleId = -10;
export const Physician = 'Physician';
export const PhysicianRoleId = -9;
export const CommunityRepresentative = 'Community Representative';
export const CommunityRepresentativeRoleId = 41;
export const Administration = 'Administration';
export const AdministrationRoleId = 45;
export const Dietician = 'Dietician';
export const DieticianRoleId = 47;
export const Acknowladgee = 'Acknowladgee';
export const AcknowladgeeRoleId = 48;
export const RefferalSource = 'RefferalSource';
export const RefferalSourceRoleId = 51;
export const HISPerson = 'HIS Person';
export const HISPersonRoleId = 52;
export const Receptionist = 'Receptionist';
export const ReceptionistRoleId = 54;
export const ClinicalVolunteer = 'Clinical Volunteer';
export const ClinicalVolunteerRoleId = 69; // role group names and ids

export const Other = 'Other';
export const OtherRoleGroupId = -34;
export const Surveyor = 'Surveyor';
export const SurveyorRoleGroupId = -32;
export const HIS = 'HIS';
export const HISRoleGroupId = -24;
export const Dietary = 'Dietary';
export const DietaryRoleGroupId = -23;
export const Pharmacy = 'Pharmacy';
export const PharmacyRoleGroupId = -22;
export const SpeechTherapy = 'Speech Therapy';
export const SpeechTherapyRoleGroupId = -19;
export const OccupationalTherapy = 'Occupational Therapy';
export const OccupationalTherapyRoleGroupId = -18;
export const Bereavement = 'Bereavement';
export const BereavementRoleGroupId = -12;
export const Volunteer = 'Volunteer';
export const VolunteerRoleGroupId = -11;
export const Spiritual = 'Spiritual';
export const SpiritualRoleGroupId = -10;
export const Aide = 'Aide';
export const AideRoleGroupId = -9; // see above for SocialWorker

export const SocialWorkerRoleGroupId = -8;
export const PhysicalTherapy = 'Physical Therapy';
export const PhysicalTherapyRoleGroupId = -5;
export const Nurse = 'Nurse';
export const NurseRoleGroupId = -4;
export const Doctor = 'Doctor';
export const DoctorRoleGroupId = -3; // see above for ClinicalVolunteer

export const ClinicalVolunteerRoleGroupId = 24;